import React from 'react';

/**
 * Branded cover that sits over the bottom-right corner of every video player —
 * specifically to cover the burned-in XbotGo / XbotGo Falcon camera watermark
 * until a sponsorship deal is in place.
 *
 * Sizing tuned to cover both standard XbotGo and the longer "XbotGo Falcon"
 * variant across phone, tablet (iPad), laptop, and desktop landscape playback.
 * Pointer-events-none so it never intercepts the player's controls.
 */
export const XbotCoverOverlay = () => (
  <div
    aria-hidden="true"
    data-testid="xbot-cover-overlay"
    className="absolute z-20 pointer-events-none select-none flex items-center justify-center bg-black/85 backdrop-blur-sm rounded-lg shadow-xl ring-1 ring-white/10"
    style={{
      bottom: 'clamp(6px, 1.2%, 18px)',
      right: 'clamp(6px, 1.2%, 18px)',
      // Generous sizing so even the wider "XbotGo Falcon" burn-in is fully covered
      // on iPad / tablet width where 15% wasn't enough.
      width: 'clamp(110px, 22%, 320px)',
      aspectRatio: '3 / 1',
      padding: 'clamp(4px, 0.8%, 12px) clamp(8px, 1.2%, 18px)',
    }}
  >
    <img
      src="/rooam-logo.png"
      alt=""
      className="w-full h-full object-contain opacity-95"
      draggable={false}
    />
  </div>
);

export default XbotCoverOverlay;
